import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { hideForumPost, unHideForumPost } from "../util/db";

function EventChatPost({ item, showHideButton = false }) {
  const [isHidden, setIsHidden] = useState(item.is_hidden);

  const handlePostHide = (e) => {
    e.preventDefault();
    hideForumPost(item.id, item.event_id);
    setIsHidden(true);
  };

  const handlePostUnHide = (e) => {
    e.preventDefault();
    unHideForumPost(item.id, item.event_id);
    setIsHidden(false);
  };

  return (
    <Col xs="12" className="">
      <Card
        style={{
          backgroundColor: isHidden ? "#ffebee" : "#ffffff",
          borderRadius: "12px",
        }}
      >
        <Card.Header
          style={{
            background: isHidden ? "#d32f2f" : "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Row>
            <Col>
              <Card.Title className="mb-0" style={{ color: "white" }}>
                {item.users_public.name}
              </Card.Title>
            </Col>
            <Col className="text-right">
              <Row>
                <Col>
                  <small>
                    <small>
                      <small>
                        {" "}
                        ({new Date(item.created_at).toLocaleString()})
                      </small>
                    </small>
                  </small>
                </Col>
                {showHideButton && (
                  <Col xs="auto">
                    {isHidden ? (
                      <span
                        onClick={handlePostUnHide}
                        style={{ cursor: "pointer", fontSize: "1.2em" }}
                        title="Unhide post"
                      >
                        🗑️
                      </span>
                    ) : (
                      <span
                        onClick={handlePostHide}
                        style={{ cursor: "pointer", fontSize: "1.2em" }}
                        title="Hide post"
                      >
                        🗑️
                      </span>
                    )}
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body
          style={{
            opacity: isHidden ? 0.7 : 1,
            textDecoration: isHidden ? "line-through" : "none",
            borderRadius: "0 0 12px 12px",
          }}
        >
          {item.post}
          {isHidden && (
            <div
              style={{
                color: "#d32f2f",
                fontStyle: "italic",
                marginTop: "0.5rem",
              }}
            >
              <small>This message has been hidden</small>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
}

export default EventChatPost;
